<template>
  <Modal v-if="showExtend"
         size="md"
         confirmText="Förläng"
         cancelText="Avbryt"
         v-on:confirm="updateSubscription()"
         v-on:cancel="$emit('close')"
         :loading="showLoader"
  >
    <div>
      <h3 class="text-t4 mb-4">Förläng bevakning</h3>
      <p>
        Vill du förlänga denna bevakning med 3 månader till
        <span class="font-bold">{{ extendedDate }}</span>?
      </p>
      <div class="relative flex flex-col gap-3 rounded-[15px] bg-gray-10 px-4 py-2 ring-1 ring-gray-light mt-4">
        <div>
          <h3 class="text-b3 font-bold">Typ av bevakning</h3>
          <p class="text-b3">{{ typeOfSubscription }}</p>
        </div>

        <div>
          <h3 class="text-b3 font-bold">Gäller till</h3>
          <p class="text-b3">{{ formatDate(waitingListPeriodTo,'YYYY-MM-DD') }}</p>
        </div>

        <div v-if="
              subscription.administrativeUnitAreas &&
              subscription.administrativeUnitAreas.length > 0
            ">
          <h3
            class="text-b3 font-bold">Områden</h3>
            <ul>
              <li
                v-if="
                  subscription.administrativeUnitAreas &&
                  subscription.administrativeUnitAreas.length > 0
                "
              >
                {{ subscription.administrativeUnitAreas.join(', ') }}
              </li>
            </ul>
        </div>

          <div v-if="rentalObjectTypeTexts.length > 0">
            <h3 class="text-b3 font-bold">Objektstyper</h3>
            <p class="text-b3">{{ rentalObjectTypeTexts.join(', ') }}</p>
          </div>

        <div v-if="maxRent">
          <h3 class="inline-block text-[14px] tracking-[0.42px] font-bold">Maxhyra</h3>
          <p class="text-b3">0-{{ maxRent }} kr/mån</p>
        </div>

        <div v-if="minArea">
          <h3 class="inline-block text-[14px] tracking-[0.42px] font-bold">Minsta yta</h3>
          <p class="text-b3">{{minArea}} m²</p>
        </div>

        <div v-if="minRooms || maxRooms">
          <h3 class="inline-block text-[14px] tracking-[0.42px] font-bold">Antal rum</h3>
          <p class="text-b3" v-if="minRooms && maxRooms">{{ minRooms }} - {{ maxRooms }} rok</p>
          <p class="text-b3" v-else-if="minRooms">Minst {{ minRooms }} rok</p>
          <p class="text-b3" v-else-if="maxRooms">Max {{ maxRooms }} rok</p>
        </div>
     </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/modal';
import ObjectTypes from '@/components/search/filters_new/objecttypes';
import TownDistricts from '@/components/search/filters_new/towndistricts';
import Rent from '@/components/search/filters_new/rent';
import Rooms from '@/components/search/filters_new/rooms';
import ObjectArea from '@/components/search/filters_new/area';
import WaitingListType from '@/components/search/filters_new/waitinglisttype';
import Loader from '@/components/ui/loader';
import SubscriptionMixin from '@/mixins/subscription';
import { RENTALOBJECT_TYPES } from '@/config/constants';
import { find, map, union } from 'lodash';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import GeneralMixin from '@/mixins/general';

export default {
  mixins: [SubscriptionMixin, GeneralMixin],
  components: {
    ObjectTypes,
    TownDistricts,
    Rent,
    Rooms,
    ObjectArea,
    Loader,
    WaitingListType,
    CardLoaderSmall,
    Modal
  },
  props: {
    showExtend: {
      type: Boolean,
      required: true,
    },
    subscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLoader: false,
      RENTALOBJECT_TYPES,
    };
  },
  computed: {
    _subscription() {
      return { ...this.subscription };
    },
    rentalObjectTypeTexts() {
      if (this._subscription.objectType === RENTALOBJECT_TYPES.APARTMENT) {
        return map(this._subscription.rentalObjectTypes, (subRentalObjectType) => {
          const type = find(this.config.rentalObjectTypes, (configRentalObjectTypes) => {
            return subRentalObjectType == configRentalObjectTypes.code;
          });

          if (type) return type.caption;
        });
      }
      if (this._subscription.objectType === RENTALOBJECT_TYPES.PARKING) {
        return map(this._subscription.rentalObjectTypes, (subRentalObjectType) => {
          const type = find(
            union(this.config.vehicleSpaceTypes, this.config.rentalObjectTypes),
            (configRentalObjectTypes) => {
              return subRentalObjectType == configRentalObjectTypes.code;
            },
          );

          if (type) return type.caption;
        });
      }
      return [];
    },
    isStudentApartment() {
      if (this._subscription && this._subscription.waitingListTypeCaption) {
        return !!this._subscription.waitingListTypeCaption.match('Prenumeration, student');
      }

      return false;
    },
  },
  created() {
    this.filters.rentalObjectTypes = this.subscription.rentalObjectTypes;
    this.filters.administrativeUnitAreas = this.subscription.administrativeUnitAreas;
    this.filters.maxRent = this.subscription.maxRent;
    this.filters.minArea = this.subscription.minArea;
    this.filters.maxArea = this.subscription.maxArea;
    this.filters.minRooms = this.subscription.minRooms;
    this.filters.maxRooms = this.subscription.maxRooms;
    this.filters.waitingListType = this.subscription.waitingListType;
  },
  methods: {
    cancel() {
      this.$emit('close');
      $(this).focus();
    },
    updateSubscription() {
      this.showLoader = true;
      return SubscriptionMixin.methods.updateSubscription.call(this).then(() => {
        this.$emit('close');
      });
    },
  },
};
</script>
